// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__1kRTM","tab":"Tabs_tab__X52T4","active":"Tabs_active__uGUKx"};